import { TranslationKey } from './../../../../types/translation/TranslationKey';
import React, { useContext, useMemo, useState } from 'react';
import { t } from '../../../../types/translation/Translator';
import { useNavigate } from 'react-router-dom';
import Table from '../../../components/Table/Table';
import SearchBarWithFilter from '../../../../VentoryUI/components/common/SearchBarWithFilter/SearchBarWithFilter';
import { LotFilter } from '../../../../VentoryUI/components/filters/LotFilter';
import { LotContext } from '../../../../context/LotContext';
import { Lot } from '../../../../types/lot/lot';
import { LotTable } from '../../Common/LotTable';
import { ProductMasterDataContext } from '../../../../context/ProductMasterDataContext';
import { CompanyContext } from '../../../../context/CompanyContext';
import CreateLotModal from './CreateLotModal';
import { Routing } from '../../../../util/routes.util';
import { CustomFieldContext } from '../../../../context/CustomFieldContext';
import LotImportModal from './LotImportModal';
import { CreateButton, ImportIconButton } from '../../../components/Button';
import { CompanyRoleAssignmentContext } from '../../../../context/CompanyRoleAssignmentContext';
import { SettingsIconButton } from '../../../icons';
import { TagRelationContext } from '../../../../context/TagRelationContext';
import { User } from '../../../../types/user';
import { UserContext } from '../../../../context/UserContext';
import { TableSettingsContext } from '../../../../context/TableSettingsContext';
import { EntityType } from '../../../../types/comment';

interface LotOverviewProps {}

export default function LotOverviewPane({}: LotOverviewProps) {
  const navigate = useNavigate();

  const { currentCompany, companies } = useContext(CompanyContext);
  const { productMasterData } = useContext(ProductMasterDataContext);
  const { lots, lotsLoading } = useContext(LotContext);
  const { customFields } = useContext(CustomFieldContext);
  const { tagRelations } = useContext(TagRelationContext);
  const { isAdmin } = useContext(CompanyRoleAssignmentContext);
  const { currentUser } = useContext(UserContext);
  const { getTableSettings } = useContext(TableSettingsContext);
  const lotTableSettings = getTableSettings(EntityType.lot, currentCompany.id);

  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [importModalOpen, setImportModalOpen] = useState(false);

  const allItems = useMemo(() => {
    return [...lots.values()];
  }, [lots]);

  const [items, setItems] = useState<Lot[]>(allItems);

  const filter = new LotFilter(productMasterData, customFields, lots, tagRelations, currentCompany, lotTableSettings);

  return (
    <>
      <CreateLotModal open={createModalOpen} setOpen={setCreateModalOpen} />
      <LotImportModal open={importModalOpen} setOpen={setImportModalOpen} />

      <div className='flex h-full flex-col gap-4'>
        <div className='flex justify-between gap-4'>
          <SearchBarWithFilter
            loading={lotsLoading}
            items={allItems}
            setItems={setItems}
            placeholder={t(TranslationKey.filterLot).plural.label}
            filter={filter}
          />
          <div className='flex gap-2'>
            <CreateButton onClick={() => setCreateModalOpen(true)} />
            <ImportIconButton onClick={() => setImportModalOpen(true)} />
            {isAdmin && <SettingsIconButton onClick={() => navigate(Routing.stock.lots.settings.overview())} />}
          </div>
        </div>
        <Table
          loading={lotsLoading}
          items={items}
          totalItemCount={allItems.length}
          headers={LotTable.header(
            productMasterData,
            companies,
            lotTableSettings,
            currentCompany,
            User.locale(currentUser),
          )}
          filter={filter}
          onClick={item => navigate(Routing.stock.lots.detail(item.id))}
        />
      </div>
    </>
  );
}
